import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "custom-breadcrumbs" }
const _hoisted_2 = { class: "breadcrumb-item breadcrumb-current" }
const _hoisted_3 = {
  key: 2,
  class: "breadcrumb-divider"
}

interface BreadcrumbItem {
  text: string
  to?: string
  disabled?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBreadcrumb',
  props: {
    items: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createCommentVNode(" Link item (not last) "),
        (index < __props.items.length - 1)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: item.to,
              class: "breadcrumb-item"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" Current item (last) "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(item.text), 1 /* TEXT */)
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
        _createCommentVNode(" Divider (not after last item) "),
        (index < __props.items.length - 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/"))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})